import { createFileRoute } from "@tanstack/react-router";

import AudiolabSection from "@/components/marketing/AudiolabSection";
import FinalCta from "@/components/marketing/FinalCta";
import { marketingHead } from "@/components/marketing/marketingHead";
import ArtistBand from "@/components/marketing/overview/ArtistBand";
import LabelsCallout from "@/components/marketing/overview/LabelsCallout";
import OverviewHero from "@/components/marketing/overview/OverviewHero";
import SellOverviewSection from "@/components/marketing/SellOverviewSection";
import SuperSingleOverview from "@/components/marketing/SuperSingleOverview";
import Footer from "@/components/nav/Footer";

export const Route = createFileRoute("/artists")({
  component: ArtistsPage,
  head: () =>
    marketingHead({
      title: "Lutely Products | Prepare, Package, and Sell Your Music",
      description:
        "Explore Lutely's tools for preparing, releasing, and selling music.",
      path: "/artists",
    }),
});

function ArtistsPage() {
  return (
    <main className="flex flex-col bg-white">
      <OverviewHero />
      <ArtistBand />
      <AudiolabSection />
      <SellOverviewSection />
      <SuperSingleOverview />
      <LabelsCallout />
      <FinalCta
        title="Prepare. Package. Sell."
        body="Upload once and keep every asset, release, and sale connected."
      />
      <Footer topClassName="bg-[#050923]" />
    </main>
  );
}
